import { UseQueryResult } from '@tanstack/react-query'
import { UserInfoData, getUserInfo } from '@tmap-web-lib/remote-api-client/frontman'
import { AxiosError } from 'axios'
import { useAtomValue } from 'jotai'

import { mockHost } from '@/apis'
import { storageMockEnabled } from '@/atoms'
import { useQueryWrapper } from '@/hooks/useQueryWrapper'
import { KEYS } from '@/react-query/keys'

interface Props {
  enabled?: boolean
  useErrorBoundary: boolean
}

function useGetUserInfo(props?: Props): UseQueryResult<UserInfoData, AxiosError> {
  const storageMock = useAtomValue(storageMockEnabled)

  return useQueryWrapper<UserInfoData, AxiosError>(
    KEYS.USER_INFO(),
    async () => {
      if (storageMock) {
        const { data } = await mockHost.get('/heimdall/heimdall-rmi/api/user/$userKey')
        return data
      } else {
        const { data } = await getUserInfo()
        return data
      }
    },
    {
      enabled: props?.enabled ?? true,
      useErrorBoundary: props?.useErrorBoundary ?? true,
    }
  )
}

export { useGetUserInfo }
